// src/components/common/PromoSpot.jsx
import React, { useState } from "react";
import "./PromoSpot.css";

const PromoSpot = ({ promo, onCtaClick, onExpand, onClickTrack }) => {
  const [expanded, setExpanded] = useState(false);

  if (!promo || promo.active === false) return null;

  const {
    imageUrl,
    title,
    subtitle,
    ctaLabel,
    topLabel,
  } = promo;

  const navigatePromo = () => {
    // track click before navigation
    if (typeof onClickTrack === "function") {
      onClickTrack(promo);
    }

    if (typeof onCtaClick === "function") {
      onCtaClick(promo);
      return;
    }

    // Fallback generic behaviour
    const promoTargetType =
      promo.targetType || (promo.externalUrl ? "external" : "internal");

    const promoUrl =
      promoTargetType === "external" && promo.externalUrl
        ? promo.externalUrl
        : promo.ctaPath || "#";

    if (!promoUrl || promoUrl === "#") return;

    const openInNewTab =
      promo.openInNewTab ?? (promoTargetType === "external");

    if (openInNewTab) {
      window.open(promoUrl, "_blank", "noopener,noreferrer");
    } else {
      window.location.href = promoUrl;
    }
  };

  // Image click: first time = open (view), second time = navigate
  const handleImageClick = () => {
    if (!expanded) {
      setExpanded(true);
      if (typeof onExpand === "function") {
        onExpand(promo); // this is a "view"
      }
    } else {
      navigatePromo();
    }
  };

  const handleCtaClick = (e) => {
    e.stopPropagation();
    navigatePromo();
  };

  return (
    <div className={`promo-spot-root ${expanded ? "is-expanded" : ""}`}>
      {/* 300x100 clickable image */}
      <button
        type="button"
        className="promo-spot"
        onClick={handleImageClick}
        aria-expanded={expanded}
      >
        <div className="promo-spot-inner">
          <span className="promo-spot-ad-badge">Ad</span>

          {topLabel && (
            <span className="promo-spot-top-label">{topLabel}</span>
          )}

          <img
            src={imageUrl}
            alt={title || "MikDok promo"}
            className="promo-spot-img"
          />
        </div>
      </button>

      {/* Sliding description */}
      <div
        className={`promo-spot-details ${
          expanded ? "promo-spot-details-open" : ""
        }`}
      >
        <div className="promo-spot-details-inner">
          {title && <h4 className="promo-spot-title">{title}</h4>}
          {subtitle && (
            <p className="promo-spot-subtitle">{subtitle}</p>
          )}

          {ctaLabel && (
            <button
              type="button"
              className="promo-spot-cta"
              onClick={handleCtaClick}
            >
              {ctaLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PromoSpot;
